<template>
  <div>
    <h2>Aanpassen</h2>
    <div class="row">
      <div class="col-md-3">
        <div class="list-group">
          <a
            href="#"
            class="list-group-item"
            @click="activeItem = 'startPagina'"
            :class="{ active: activeItem == 'startPagina' }"
            >Startpagina</a
          >
          <a
            href="#"
            class="list-group-item"
            @click="activeItem = 'geboortelijst'"
            :class="{ active: activeItem == 'geboortelijst' }"
            >Geboortelijst</a
          >
          <a
            href="#"
            class="list-group-item"
            @click="activeItem = 'contactPagina'"
            :class="{ active: activeItem == 'contactPagina' }"
            >Contactpagina</a
          >
          <a
            href="#"
            class="list-group-item"
            @click="activeItem = 'algemeen'"
            :class="{ active: activeItem == 'algemen' }"
            >Algemeen</a
          >
        </div>
        <br />
        <button
          class="btn btn-outline-info"
          @click="$alertify.confirm('Zeker weten?', save)"
        >
          Opslaan!
        </button>
      </div>
      <div class="col">
        <div v-show="activeItem == 'startPagina'">
          <h3>Startpagina</h3>

          <div class="form-group">
            <label for="naamkindje">Naam kindje</label>
            <input
              type="text"
              name="naamkindje"
              class="form-control"
              v-model="config.naamkindje"
            />
          </div>

          <div class="form-group">
            <label for="welcomeTitle">Verwelkoming</label>
            <input
              type="text"
              name="welcomeTitle"
              class="form-control"
              v-model="config.welcomeTitle"
            />
          </div>
          <div class="form-group">
            <label for="welcomeText">Tekstje startpagina</label>
            <textarea
              rows="10"
              type="text"
              name="welcomeText"
              id
              v-model="config.welcomeText"
              class="form-control"
            ></textarea>
          </div>
          Voeg hier afbeeldingen toe aan de startpagina.
          <file-pond
            name="homeCarousel"
            label-idle="Sleep een afbeelding hier..."
            allow-multiple="true"
            accepted-file-types="image/jpeg,image/png"
            :server="serverHomeCarousel"
            imageResizeTargetWidth="1600"
            imageResizeTargetHeight="1600"
            imageResizeMode="contain"
            :allowImageCrop="false"
            allowImageExifOrientation="true"
            :imageTransformVariants="thumbnail"
          ></file-pond>
          <template v-if="!$_.isEmpty(homeCarousel)">
            <hr />
            <p>
              Sleep afbeeldingen om de volgorde te wijzigen. Klik met rechts om
              ze te verwijderen.
            </p>
            <div class="card-columns">
              <draggable
                v-model="homeCarousel"
                @start="drag = true"
                @end="drag = false"
                scroll="true"
                scrollSensitivity="300"
                :scrollSpeed="50"
              >
                <!-- <div class="card-columns"> -->
                <div class="card" v-for="(item, idx) in sortedHomeCarousel">
                  <img
                    :key="idx"
                    height="50"
                    class="card-img-top img-fluid"
                    :src="item.img"
                    @contextmenu.prevent="remove(item.id, item.img_id)"
                  />
                  <textarea
                    type="text"
                    name
                    id
                    class="form-control"
                    v-model="item.caption"
                    :key="'caption_' + idx"
                    placeholder="Tekstje bij foto"
                    @change="saveCaption(item)"
                    rows="3"
                  />
                </div>
                <!-- </div> -->
              </draggable>
            </div>
          </template>
        </div>
        <div v-show="activeItem == 'geboortelijst'">
          <h3>Geboortelijst</h3>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" v-model="config.hideList"></input>
            <label class="form-check-label" for="config.hideList">Verstop heel de lijst, ook de link ernaartoe?</label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" v-model="config.show_gift_suggestions"></input>
            <label class="form-check-label" for="config.hideList">Geef suggesties voor bedrag?</label>
          </div>
          <div class="form-check ml-3">
            <input class="form-check-input" type="checkbox" v-model="config.ask_for_address"></input>
            <label class="form-check-label" for="config.hideList">Vraag adres?</label>
          </div>
          <div class="form-group">
            <label for="listText">Tekstje lijst</label>
            <textarea
              rows="8"
              type="text"
              name
              class="form-control"
              v-model="config.listText"
            />
          </div>
        </div>
        <div v-show="activeItem == 'contactPagina'">
          <h3>contactPagina</h3>
          <div class="form-group">
            <label for="label§">Naam</label>
            <input
              type="text"
              name="label1"
              class="form-control"
              v-model="config.name"
            />
          </div>
          <div class="form-group">
            <label for="label§">Addreslijn 1</label>
            <input
              type="text"
              name="label2"
              class="form-control"
              v-model="config.address1"
            />
          </div>
          <div class="form-group">
            <label for="label§">Addreslijn 2</label>
            <input
              type="text"
              name="label3"
              class="form-control"
              v-model="config.address2"
            />
          </div>
          <div class="form-group">
            <label for="label§">Land</label>
            <input
              type="text"
              name="label4"
              class="form-control"
              v-model="config.country"
            />
          </div>
          <div class="form-group">
            <label for="label§">Telefoon 1</label>
            <input
              type="text"
              name="label5"
              class="form-control"
              v-model="config.phone1"
            />
          </div>
          <div class="form-group">
            <label for="label§">Telefoon 2</label>
            <input
              type="text"
              name="label6"
              class="form-control"
              v-model="config.phone2"
            />
          </div>
          <div class="form-group">
            <label for="label§">Email</label>
            <input
              type="text"
              name="label7"
              class="form-control"
              v-model="config.email"
            />
          </div>
          <div class="form-group">
            <label for="label§">Tekstje</label>
            <input
              type="text"
              name="label7"
              class="form-control"
              v-model="config.contactMsg"
            />
          </div>
          <div class="form-group">
            <label for="label8">Coördinaten</label>
            <input
              type="text"
              name="label8"
              class="form-control"
              v-model="config.coordinates"
            />
          </div>

          <div id="map" height="300" width="300"></div>
        </div>
        <div v-show="activeItem == 'algemeen'">
          <h3>Algemeen</h3>
          <div class="form-group">
            <label for="label8">Rekeningnummer</label>
            <input
              type="text"
              name="label8"
              class="form-control"
              v-model="config.bankaccount"
            />
          </div>
          <div class="form-group">
            <label for="label8">Naam</label>
            <input
              type="text"
              name="label8"
              class="form-control"
              v-model="config.name"
            />
          </div>
          <div class="form-group">
            <label for="label8">URL</label>
            <input
              type="text"
              name="label8"
              class="form-control"
              v-model="config.url"
            />
          </div>
        </div>
        <!-- <div class="row">
          <button class="btn btn-outline-primary" @click="save">Opslaan</button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";
import L from "leaflet";

let guid = () => {
  let s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4();
};
export default {
  data() {
    return { saving: undefined, activeItem: "startPagina" };
  },
  components: {
    draggable,
    filePond: () => import("./filepond"),
  },
  computed: {
    ...mapState(["config"]),
    coords() {
      return this.$_.split(this.config.coordinates, ",");
    },
    // ...mapState(["homeCarousel"]),
    sortedHomeCarousel() {
      return this.$_.sortBy(this.homeCarousel, "order");
    },
    homeCarousel: {
      get() {
        return this.$store.state.homeCarousel;
      },
      set(val) {
        this.$_.forEach(val, async (x, idx) => {
          if (x.order != idx) {
            x.order = idx;
            await this.$firebase
              .firestore()
              .collection("homepage")
              .doc(x.id)
              .set(x);
          }
        });
        this.$store.commit("setHomeCarousel", val);
      },
    },
    thumbnail() {
      return {
        thumbnail_: (transforms) => {
          transforms.resize.size.width = 128;
          return transforms;
        },
      };
    },

    serverHomeCarousel() {
      return {
        process: (
          fieldName,
          file,
          metadataOrig,
          load,
          error,
          progress,
          abort
        ) => {
          if (!this.saving) this.saving = 0;
          this.saving -= 1;

          try {
            let metadata = { contentType: file.type };
            let ref = this.$firebase.storage().ref();
            let uid = guid();
            let thumbnail = this.$_.find(file, (x) => x.name == "thumbnail_");
            let large = this.$_.find(file, (x) => x.name != "thumbnail_");
            let task = ref.child(`/homepage/${uid}`).put(large.file, metadata);
            let coll = this.$firebase.firestore().collection("homepage");

            task.on(
              "state_changed",
              (snapshot) => {
                progress(
                  true,
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
                  100
                );
              },
              (err) => {
                this.$alertify.error(err);
                error();
              },
              async () => {
                let url = await task.snapshot.ref.getDownloadURL();
                let item = { img_id: uid };
                item.img = url;
                item.ratio =
                  parseFloat(metadataOrig.size.height) /
                  parseFloat(metadataOrig.size.width);
                if (metadataOrig.exif && metadataOrig.exif.orientation == 6)
                  item.ratio = 1 / item.ratio;
                var reader = new FileReader();
                reader.addEventListener(
                  "load",
                  async () => {
                    item.img_thumb = reader.result;
                    let resp = await coll.add(item);
                    load(resp.text);
                    this.saving += 1;
                    let snapshot = await coll.get();
                    let carousel = [];
                    snapshot.forEach((doc) => {
                      let data = doc.data();
                      data.id = doc.id;
                      carousel.push(data);
                    });
                    this.$alertify.success("Foto succesvol toegevoegd!");
                    this.$store.commit("setHomeCarousel", carousel);
                  },
                  false
                );
                reader.readAsDataURL(thumbnail.file);
              }
            );
          } catch (err) {}
        },
      };
    },
  },
  methods: {
    async save() {
      let coll = this.$firebase.firestore().collection("config");

      if (this.config.id) {
        coll.doc(this.config.id).set(this.config);
      } else {
        let data = await coll.add(this.config);
      }
      this.$router.replace({ name: "home" });
    },
    remove(id, img_id) {
      this.$alertify.confirm("Zeker dat je deze wil verwijderen?", async () => {
        await this.$firebase
          .storage()
          .ref()
          .child(`homepage/${img_id}`)
          .delete();
        this.$firebase.firestore().collection("homepage").doc(id).delete();
        let car = this.$_.cloneDeep(this.homeCarousel);
        this.$_.remove(car, (x) => x.id == id);
        this.$store.commit("setHomeCarousel", car);
      });
    },
    saveCaption: _.debounce(async function (item) {
      await this.$firebase
        .firestore()
        .collection("homepage")
        .doc(item.id)
        .set(item);
    }, 250),
  },
  watch: {
    async config(newval, oldval) {
      // let map = L.map("map", { center: this.coords, zoom: 16, maxZoom: 16});
      // var Stamen_Watercolor = L.tileLayer(
      //   "https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.{ext}",
      //   {
      //     attribution:
      //       'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      //     subdomains: "abcd",
      //     minZoom: 1,
      //     maxZoom: 16,
      //     ext: "jpg"
      //   }
      // ).addTo(map);
      // var Stamen_TonerLabels = L.tileLayer(
      //   "https://stamen-tiles-{s}.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}{r}.{ext}",
      //   {
      //     attribution:
      //       'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      //     subdomains: "abcd",
      //     minZoom: 0,
      //     maxZoom: 20,
      //     ext: "png"
      //   }
      // ).addTo(map);
    },
  },
};
</script>
